import { render, staticRenderFns } from "./choose-intercom-source.vue?vue&type=template&id=1ee2fba5&"
import script from "./choose-intercom-source.vue?vue&type=script&lang=js&"
export * from "./choose-intercom-source.vue?vue&type=script&lang=js&"
import style0 from "./choose-intercom-source.vue?vue&type=style&index=0&id=1ee2fba5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports